import { useState } from "react";
import { Alert, Button, Form, Modal } from "react-bootstrap";
import { DataHandler } from "../dataHandler";
import { Buchung, toInputValue } from "./zeitData";

export type ZeitEditProps = {
    /** undefined = neue Buchung */
    buchung?: Buchung,
    defaultUser: string,
    von: string,
    bis: string,
    onSaved: (zeiten: Array<Buchung>) => void,
    onAbort: () => void,
    onError: (text: string) => void
}

/**
 * Buchung anlegen oder ändern. Hier wird bewusst nicht gerundet - der
 * eingetragene Wert wird vom Backend genau so übernommen.
 */
export default function ZeitEdit(props: ZeitEditProps) {

    const buchung = props.buchung;

    const [user, setUser] = useState<string>(buchung ? buchung.user : props.defaultUser);
    const [kommen, setKommen] = useState<string>(buchung ? toInputValue(buchung.kommenDatumZeit) : '');
    const [gehen, setGehen] = useState<string>(buchung ? toInputValue(buchung.gehenDatumZeit) : '');
    const [kommentar, setKommentar] = useState<string>(buchung ? buchung.kommentar : '');
    const [hinweis, setHinweis] = useState<string | undefined>();
    const [busy, setBusy] = useState<boolean>(false);

    const save = () => {
        if (user.trim().length === 0) {
            setHinweis('Bitte einen Benutzer angeben.');
            return;
        }
        if (kommen.length === 0) {
            setHinweis('Bitte ein Kommen angeben.');
            return;
        }
        if (gehen.length > 0 && gehen <= kommen) {
            setHinweis('Gehen muss nach Kommen liegen.');
            return;
        }
        setHinweis(undefined);
        setBusy(true);
        DataHandler.storeZeit({
            id: buchung ? String(buchung.id) : '',
            user: user.trim(),
            kommen: kommen,
            gehen: gehen.length > 0 ? gehen : null,
            kommentar: kommentar,
            von: props.von,
            bis: props.bis
        }).then((zeiten: Array<Buchung>) => {
            props.onSaved(zeiten);
        }).catch((text: string) => {
            props.onError(text);
        }).finally(() => {
            setBusy(false);
        });
    }

    return (<Modal show={true} onHide={props.onAbort}>
        <Modal.Header closeButton>
            <Modal.Title>{buchung ? 'Buchung bearbeiten' : 'Neue Buchung'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {hinweis && <Alert variant="warning">{hinweis}</Alert>}
            <Form>
                <Form.Group className="mb-3" controlId="zeitUser">
                    <Form.Label>Benutzer</Form.Label>
                    <Form.Control type="text" value={user} onChange={(e) => setUser(e.target.value)} />
                </Form.Group>
                <Form.Group className="mb-3" controlId="zeitKommen">
                    <Form.Label>Kommen</Form.Label>
                    <Form.Control type="datetime-local" value={kommen} onChange={(e) => setKommen(e.target.value)} />
                </Form.Group>
                <Form.Group className="mb-3" controlId="zeitGehen">
                    <Form.Label>Gehen</Form.Label>
                    <Form.Control type="datetime-local" value={gehen} onChange={(e) => setGehen(e.target.value)} />
                    <Form.Text muted>Leer lassen ergibt eine offene Buchung.</Form.Text>
                </Form.Group>
                <Form.Group className="mb-3" controlId="zeitKommentar">
                    <Form.Label>Kommentar</Form.Label>
                    <Form.Control type="text" value={kommentar} onChange={(e) => setKommentar(e.target.value)} />
                </Form.Group>
            </Form>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="primary" disabled={busy} onClick={save}>Speichern</Button>
            <Button variant="secondary" disabled={busy} onClick={props.onAbort}>Abbrechen</Button>
        </Modal.Footer>
    </Modal>);
}
